/* eslint-disable @typescript-eslint/no-loss-of-precision */
import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenFieldProps, ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const High = ({ codeItem, updateByKey, resetValidation, readOnlyConfig, translation, validation }: ScreenFieldProps) => {

  const onChange = (value: number) => {
    resetValidation(ScreenField.high);
    updateByKey(ScreenField.high, value);
  };

  const highValidation = !!validation && !!validation[ScreenField.high] ? validation[ScreenField.high] : undefined;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId={ScreenField.high}
      readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.all]}
      label={{ text: translation.high }}
      value={codeItem && codeItem.high}
      onChange={onChange}
      useThousand=" "
      maxValue={9999999999.999999999}
      minValue={-9999999999.999999999}
      textInvalidRangeError={translation.must_be_within_range}
      maxDecimals={9}
      validation={highValidation}
    />
  </div>;
};
